module.exports = __webpack_public_path__ + "img/bicester-village.a2434575.jpg";